export enum COLUMN_NAMES {
  RESOURCE_COST = 'resourceCost',
  RESOURCE_NAME = 'resourceName',
  RESOURCE_ID = 'resourceId',
  SERVICE = 'service',
  REGION = 'region',
  LINKED_ACCOUNT = 'linkedAccount',
  TAGS = 'tags',
  GOVERNANCE_TAGS = 'governanceTags',
  LAST_UPDATE = 'lastUpdate',
  GOVERNANCE_TAG_ACTION = 'governanceTagAction',
  TAG_ICON = 'tagIcon',
  CHECKBOX = 'checkbox',
}
